import React from "react";
import { GoStar } from "react-icons/go";

export default function Features() {
  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-center mb-12">
        <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-800">
          Achievements
        </h1>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {[
          {
            title: "Featured in the UN Youth Summit 2019",
            desc: "Represented youth leadership and innovation on a global platform at the UN Youth Summit 2019.",
          },
          {
            title: "Leo Club Excellence Award, top 10 in INDIA",
            desc: "Honored among the top 10 Leo Clubs in India with the Excellence Award for impactful service and leadership.",
          },
          {
            title: "Project Dhruvtara was recipient of Diana Awards",
            desc: "Project Dhruvtara received the prestigious Diana Award for outstanding social impact and youth-led change.",
          },
          {
            title: "Led successful national & international collaborations",
            desc: "Spearheaded impactful collaborations across national and international platforms to drive youth engagement and social change.",
          },
          {
            title: "Pride of the district award 2022-2023",
            desc: "Recognized as the Pride of the District for exceptional contributions to community service in 2022-23.",
          },
          {
            title: "Club Appreciation Award from Lion Region 10 (2022-23)",
            desc: "Awarded by Lion Region 10 for exemplary club performance and community initiatives in 2022-23.",
          },
        ].map((item, idx) => (
          <div
            key={idx}
            className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300"
          >
            <div className="flex items-center mb-4">
              <GoStar className="text-blue-500" size={25} />
              <div className="ml-4 text-lg font-semibold text-gray-800">
                {item.title}
              </div>
            </div>
            <p className="text-gray-600 text-sm">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
